@use './_resource.scss' as *;

@include module;